import type { FC } from 'react'
import { useThreadStatus } from '@/features/agent/ThreadStatusContext'

const fmt = (n: number): string => {
  if (n >= 1000) return `${(n / 1000).toFixed(n >= 10_000 ? 0 : 1)}k`
  return `${n}`
}

/** Text-only thread-token usage indicator. Quiet under 70%; turns amber at
 *  70%, red at 90%. Hidden until the host has a token count. Designed to be
 *  rendered inline with the composer hints row. */
export const ThreadContextIndicator: FC = () => {
  const { tokensUsed, budgetTokens } = useThreadStatus()
  if (tokensUsed === undefined || !budgetTokens) return null

  const pct = Math.round((tokensUsed / budgetTokens) * 100)
  const tone = pct >= 90 ? 'text-destructive' : pct >= 70 ? 'text-warning' : ''

  return (
    <span className={tone}>
      {fmt(tokensUsed)} / {fmt(budgetTokens)} tokens
    </span>
  )
}
